import React from 'react'
import circleCheck from '../../../../assets/production-flow/rnc/circle-check.svg'
import {
  ModalOverlay,
  ModalContainer,
  IconWrapper,
  Title,
  Description,
  ButtonContainer,
  CloseButton,
  ReportButton,
} from './style'

interface RNCSuccessModalProps {
  isOpen?: boolean
  onClose?: () => void
  onGoToReports?: () => void
}

const RNCSuccessModal: React.FC<RNCSuccessModalProps> = ({
  isOpen = false,
  onClose = () => {},
  onGoToReports = () => {},
}) => {
  if (!isOpen) return null

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e: { stopPropagation: () => any }) => e.stopPropagation()}>
        <IconWrapper>
          <img src={circleCheck} alt="Sucesso" width={24} height={24} />
        </IconWrapper>

        <Title>Registro de Não Conformidade gerado com sucesso!</Title>

        <Description>
          Você pode acompanhar este e outros RNCs no banco de dados de relatórios.
        </Description>

        <ButtonContainer>
          <CloseButton onClick={onClose}>Fechar</CloseButton>
          <ReportButton onClick={onGoToReports}>
            Ir para relatórios
          </ReportButton>
        </ButtonContainer>
      </ModalContainer>
    </ModalOverlay>
  )
}

export default RNCSuccessModal